import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';

const CsvButton = (props) => (
  <div>
    <Button
      onClick={props.onClick}
      title="Download CSV"
      key="Button"
    >
      CSV
    </Button>
  </div>
);

CsvButton.propTypes = {
  onClick: PropTypes.func,
};

export default CsvButton;



// WEBPACK FOOTER //
// ./app/components/Chart/DownloadButtons/csv_button.js